import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import './styles.css';
import Dropdown from "../Dropdown";
import { useMainContext } from "../../../contexts/MainContext";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy, faPlusCircle, faTrash } from '@fortawesome/free-solid-svg-icons';
import InputUploadFiles from "../InputUploadFiles";

const ModalAddTemplates = (props) => {

    const { showModal, setShow } = props;
    const [formData, setFormData] = useState({});

    const handleClose = () => {
        setFormData({});
        setShow(false);
    };

    return (
        <section>
            <Modal
                className="cardAddTemplates"
                size={"xl"}
                show={showModal}
                onHide={handleClose}
                backdrop="static"
                centered
            >
                <div className="custom-card">
                    <div className="custom-card-header px-3 d-flex">
                        <h4 className="py-3">Nueva Plantilla</h4>
                    </div>

                    <div className="template-layout">
                        <div className="template-left">
                            <div className="row-2">
                                <div className="input-block">
                                    <label><b>Nombre de la Plantilla</b></label>
                                    <input type="text" placeholder="Nombre" className="input-text" />
                                </div>
                                <div className="input-block small">
                                    <label><b>Giro</b></label>
                                    <Dropdown placeholder="Seleccionar" />
                                </div>
                                <div className="attach-wrapper">
                                    <label><b>Herramienta</b></label>
                                    <button className="btn btn-primary">
                                        Adjuntar Encuesta
                                    </button>
                                </div>
                            </div>
                            <div className="add-row-btn">
                                <FontAwesomeIcon icon={faPlusCircle} className="icon-add" />
                            </div>

                            <div className="table-wrapper">
                                <table className="master-table">
                                    <thead>
                                        <tr>
                                            <th>Orden</th>
                                            <th>Máster Item</th>
                                            <th>ID Máster Item</th>
                                            <th>Tipo</th>
                                            <th>Valor</th>
                                            <th>Descripción</th>
                                            <th>Eliminar</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {[1, 2, 3, 4, 5, 6, 7, 8].map((n, i) => (
                                            <tr key={i}>
                                                <td>{n}</td>
                                                <td></td>
                                                <td>MXXXX</td>
                                                <td>{i % 2 === 0 ? "Cerrada" : "Abierta"}</td>
                                                <td>{i % 2 === 0 ? "Rango" : "Texto"}</td>
                                                <td></td>
                                                <td>
                                                    <FontAwesomeIcon icon={faTrash} className="icon-delete" />
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                            <div className="bottom-buttons">
                                <button className="btn btn-white" onClick={handleClose}>Cancelar</button>
                                <button className="btn btn-primary ml-3">Agregar</button>
                            </div>
                        </div>
                        <div className="template-right">
                            <div className="input-block">
                                <label><b>Menú de Máster Items</b></label>
                                <input type="text" className="input-text" placeholder="Nombre" />
                            </div>

                            <div className="master-items-panel">
                                <div className="master-item-title" >
                                    <span>Máster Item</span>
                                </div>
                                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((item, idx) => (
                                    <div className="master-item-row" key={idx}>
                                        <span>Máster Item {item}</span>
                                        <FontAwesomeIcon icon={faCopy} className="copy-icon" />
                                    </div>
                                ))}
                            </div>

                            <button className="btn btn-primary mt-3 w-100">
                                Crear Nuevo Máster Item
                            </button>

                        </div>
                    </div>
                </div>
            </Modal>
        </section>
    );
};
export default ModalAddTemplates;
